// import React, { useState } from "react";
// import {
//   Modal,
//   ModalBody,
//   ModalFooter,
//   ModalContent,
//   Button,
//   Input,
// } from "@nextui-org/react";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { useDispatch } from "react-redux";
// import { refreshIfNeeded } from "../store/actions/refreshIfNeeded";

// const RevertModal = ({ isOpen, onClose, quoteId, onConfirmRevert }) => {
//   const [revertReason, setRevertReason] = useState("");
//   const [loading, setLoading] = useState(false);
//   const dispatch = useDispatch();

//   const authHeaders = () => ({
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//       "Content-Type": "application/json",
//     },
//   });

//   const ensureAuth = async () => {
//     // If your refresh action returns a promise, awaiting it ensures fresh token
//     await dispatch(refreshIfNeeded());
//     return authHeaders();
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!revertReason.trim()) return;

//     setLoading(true);
//     try {
//       const headers = await ensureAuth();
//       await axios.post(
//         `${process.env.REACT_APP_SERVER_URL}/payment/${quoteId}/status/revert`,
//         { reason: revertReason.trim() },
//         headers
//       );

//       toast.success("Payment reverted successfully!");
//       setRevertReason("");
//       onClose?.();
//       onConfirmRevert?.(); // refresh parent (e.g., refetch quote)
//     } catch (error) {
//       const errMessage =
//         error?.response?.data?.message || "Something went wrong!";
//       toast.error(errMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal
//       size="sm"
//       isOpen={isOpen}
//       onClose={onClose}
//       className="p-3"
//       placement="center"
//     >
//       <ModalContent>
//         <form onSubmit={handleSubmit}>
//           <ModalBody className="flex flex-col items-center space-y-2">
//             <h1 className="font-semibold text-lg">Revert Payment</h1>
//             <hr className="w-full border-gray-300" />
//             <Input
//               label="Reason for Revert"
//               placeholder="Enter reason..."
//               value={revertReason}
//               onValueChange={setRevertReason} // ✅ NextUI v2 recommended
//               isDisabled={loading}
//             />
//           </ModalBody>

//           <ModalFooter className="flex justify-center gap-4">
//             <Button
//               color="danger"
//               variant="light"
//               onPress={onClose} // ✅ NextUI v2 prefers onPress
//               isDisabled={loading}
//             >
//               Cancel
//             </Button>

//             <Button
//               type="submit" // ✅ Submit the form (reliable in modals)
//               color={revertReason.trim() ? "primary" : "default"}
//               isDisabled={!revertReason.trim() || loading}
//               isLoading={loading}
//             >
//               Confirm Revert
//             </Button>
//           </ModalFooter>
//         </form>
//       </ModalContent>
//     </Modal>
//   );
// };

// export default RevertModal;

import React, { useState, useCallback } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalContent,
  Button,
  Input,
} from "@nextui-org/react";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { refreshIfNeeded } from "../store/actions/refreshIfNeeded";
import { removeAuth } from "../store/slices/authSlice";
import { useNavigate } from "react-router-dom";

const RevertModal = ({ isOpen, onClose, quoteId, onConfirmRevert }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authHeaders = useCallback(
    () => ({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/json",
      },
    }),
    []
  );

  const ensureAuth = useCallback(async () => {
    try {
      // same as UserMenu: refresh first, then return latest headers
      await dispatch(refreshIfNeeded());
    } catch {
      // ignore; real call will handle 401
    }
    return authHeaders();
  }, [dispatch, authHeaders]);

  const safeLogout = () => {
    localStorage.clear();
    dispatch(removeAuth());
    navigate("/login");
  };

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (!reason.trim() || busy) return;

    setBusy(true);
    try {
      const headers = await ensureAuth();
      await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/payment/${quoteId}/status/revert`,
        { reason: reason.trim() },
        headers
      );

      toast.success("Payment reverted successfully!");
      setReason("");
      onClose?.();
      onConfirmRevert?.(); // parent ko refresh karwa do
    } catch (error) {
      const status = error?.response?.status;
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!";
      toast.error(msg);
      if (status === 401) {
        toast.info("Session expired. Please log in again.");
        safeLogout();
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onClose={busy ? undefined : onClose}
      className="p-3"
      placement="center"
    >
      <ModalContent>
        <form onSubmit={handleSubmit}>
          <ModalBody className="flex flex-col items-center space-y-2">
            <h1 className="font-semibold text-lg">Revert Payment</h1>
            <hr className="w-full border-gray-300" />
            <Input
              label="Reason for Revert"
              placeholder="Enter reason..."
              value={reason}
              onValueChange={setReason} // NextUI v2
              isDisabled={busy}
              autoFocus
            />
          </ModalBody>

          <ModalFooter className="flex justify-center gap-4">
            <Button
              color="danger"
              variant="light"
              onPress={onClose}
              isDisabled={busy}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color={reason.trim() ? "primary" : "default"}
              isDisabled={!reason.trim() || busy}
              isLoading={busy}
            >
              Confirm Revert
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default RevertModal;
